'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const updateItemRemainingEligibleQuantity = _ref => {
  var _state$claimEligibili, _state$claimEligibili2;
  let {
    state
  } = _ref;
  const {
    itemClaims,
    currentItemClaim
  } = state;
  if (!currentItemClaim) {
    return state;
  }
  const orderItem = (_state$claimEligibili = state.claimEligibilityInfo) === null || _state$claimEligibili === void 0 ? void 0 : _state$claimEligibili.items[currentItemClaim.uid];
  if (!orderItem || !state.claimEligibilityInfo || !orderItem.maxClaimableQuantity) throw new Error('Insufficient data to update item');
  const totalItemClaimQuantity = Object.keys(itemClaims).reduce((total, key) => {
    return itemClaims[key].uid === (currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.uid) ? total + itemClaims[key].quantity : total;
  }, 0);
  const remainingEligibleQuantity = orderItem.maxClaimableQuantity - totalItemClaimQuantity;
  return {
    ...state,
    claimEligibilityInfo: {
      ...state.claimEligibilityInfo,
      items: {
        ...((_state$claimEligibili2 = state.claimEligibilityInfo) === null || _state$claimEligibili2 === void 0 ? void 0 : _state$claimEligibili2.items),
        [currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.uid]: {
          ...orderItem,
          remainingEligibleQuantity
        }
      }
    }
  };
};

exports["default"] = updateItemRemainingEligibleQuantity;
